import {MembersPageState} from '../types/state'

export const getNoUpcomingEventsUrl = (state: MembersPageState) => state.navigation.noUpcomingEventsLinkPageUrl

export const getNoUpcomingEventsPageId = (state: MembersPageState) => state.navigation.noUpcomingEventsLinkPageId

export const getRoute = (state: MembersPageState) => state.navigation.route

export const getRouteParams = (state: MembersPageState) => state.navigation.routeParams
